import React, { useState, useEffect } from "react";
// import MainSectionLayout from "../../layout/MainSectionLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { getOrDeleteRequest, postOrPutRequest, validateData } from "../../utils/utils";
import Swal from "sweetalert2";
import FormError from "../../components/FormError";
import SelectMultiple from "../../components/SelectMultiple";
import TextArea from "../../components/TextArea";
import Input from "../../components/Input";


const InfoOrg = ({ data }) => {
    const [loading, setLoading] = useState(false)

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([])

    const [formulario, setFormulario] = useState({
        company_name: '',
        address: '',
        // state_id: '',
        // city_id: '',
        // district_id: '',
        contact_phone: '',
        contact_name: '',
        phone: '',
    })

    useEffect(() => {
        if (data) {
            setFormulario(data);
        }
    }, [data])

    const [alert, setAlert] = useState([{
        inputName: "",
        status: false,
        message: ""
    }])

    const getStates = async () => {
        let response = await getOrDeleteRequest(
            `states/filter`,
            'GET',
            null,
            false
        )

        if (response.type === 'success') {
            // console.log(response.data)
            setStates(response.data)

        }
    };

    const getCities = async (state) => {
        if (!state) {
            return;
        }

        // console.log(state)
        let response = await getOrDeleteRequest(
            `cities/by-state/${state}`,
            'GET',
            null,
            true
        )
        // console.log(response);
        if (response.type === 'success') {
            // console.log(response.data);
            setCities(response.data);
        }
    }

    const getDistricts = async (city) => {
        if (!city) {
            return;
        }

        let response = await getOrDeleteRequest(
            `districts/by-city/${city}`,
            'GET',
            null,
            true
        )

        if (response.type === 'success') {
            setDistricts(response.data)
        }
    }

    // const sendData = async () => {
    //     console.log(formulario)
    //     return;
    //     let response = await postOrPutRequest(

    //     )
    // }

    const hanldeChange = (e) => {
        // console.log(e);
        let newForm = { ...formulario };

        newForm[e.target.name] = e.target.value;
        // console.log(newForm);
        sessionStorage.setItem('infoOrg', JSON.stringify(newForm));
        setFormulario(newForm);
    };

    const validateDataForm = (e) => {
        e.preventDefault();

        let inputs = Object.entries(formulario).map(([Key, value]) => {
            return {
                name: Key,
                value: value,
            };
        });

        const datosValidados = validateData(inputs);
        // console.log(datosValidados)
        setAlert(datosValidados);

        let totalValidaciones = datosValidados.filter((input) => input.status !== false).map(() => {
            return false
        });

        if (totalValidaciones.length < 1) {
            // Swal.fire({
            //     title: 'Cargando...',
            //     text: 'Por favor espere',
            //     allowOutsideClick: false,
            //     didOpen: () => {
            //         Swal.showLoading();
            //     }
            // });
            // sendData();
        }
    }

    const allFunctions = async () => {
        setLoading(true);

        await getStates();

        if (sessionStorage.getItem('infoOrg')) {
            let info = JSON.parse(sessionStorage.getItem('infoOrg'));
            // console.log(info);

            if (info.state_id) {
                getCities(info.state_id);
            }

            if (info.city_id) {
                getDistricts(info.city_id);
            }
            
            setFormulario(info);
        }

        setLoading(false);
    }

    useEffect(() => {
        // getCities(data.state_id);
        // getDistricts(data.city_id);
        allFunctions();
    }, []);

    return (
        <>
            <form onSubmit={validateDataForm}>
                <div className="mb-2">
                    <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                        Nombre de la organización
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="company_name"
                            className="form-input"
                            onChange={(e) => hanldeChange(e)}
                            value={formulario.company_name}
                            placeholder="Ingrese el nombre de la organización"
                        />
                        {/* <FormError errors={alert} name={"company_name"} /> */}
                    </div>
                </div>
                <div className="mb-2">
                    <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                        Dirección
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="address"
                            placeholder="Ingrese la dirección de la organización"
                            className="form-input"
                            onChange={(e) => hanldeChange(e)}
                            value={formulario.address}
                        />
                        {/* <FormError errors={alert} name={"address"} /> */}
                    </div>
                </div>
                <div className="mb-2 flex flex-row gap-5">
                    <div className="w-1/2">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white capitalize">
                            Departamento
                        </label>
                        <div className="relative">
                            <SelectMultiple
                                name="state_id"
                                loading={loading}
                                array={states}
                                isMulti={false}
                                // label="Departamento"
                                required={false}
                                alert={alert}
                                value={formulario.state_id}
                                onChange={(e) => {
                                    getCities(e);
                                    hanldeChange({ target: { name: 'state_id', value: e } });
                                }}
                                placeholder="Departamento"
                            // className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6  outline-none appearance-none p-2 pr-8  text-stone-400  focus:border-turquesa dark:text-white focus-visible:shadow-none"
                            // className="border-stone-800 border-1 text-xs dark:bg-[#292929]"
                            />
                            {/* <FormError errors={alert} name={"state_id"} /> */}


                        </div>
                    </div>
                    <div className="w-1/2">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                            Municipio
                        </label>
                        <div className="relative">
                            <SelectMultiple
                                className="border-stone-800 border-1 text-xs"
                                name="city_id"
                                // label="Municipio"
                                loading={loading}
                                array={cities}
                                isMulti={false}
                                required={false}
                                alert={alert}
                                value={formulario.city_id}
                                onChange={(e) => {
                                    getDistricts(e);
                                    hanldeChange({ target: { name: 'city_id', value: e } });
                                }}
                                placeholder="Municipio"
                            // className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6  outline-none appearance-none p-2 pr-8  text-stone-400  focus:border-turquesa dark:text-white focus-visible:shadow-none"
                            />
                            {/* <FormError errors={alert} name={"city_id"} /> */}

                            {/* <FontAwesomeIcon icon={faChevronDown} className="absolute left-36 top-3 text-gray-500 text-sm" /> */}
                        </div>
                    </div>
                </div>
                <div className="mb-2">
                    <div className="w-full">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                            Distrito
                        </label>
                        <div className="relative">
                            <SelectMultiple
                                className="border-stone-800 border-1 text-xs"
                                name="district_id"
                                // label="Distrito"
                                loading={loading}
                                array={districts}
                                isMulti={false}
                                required={false}
                                alert={alert}
                                value={formulario.district_id}
                                onChange={(e) => hanldeChange({ target: { name: 'district_id', value: e } })}
                                placeholder="Distrito"
                            // className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6  outline-none appearance-none p-2 pr-8  text-stone-400  focus:border-turquesa dark:text-white focus-visible:shadow-none"

                            />
                            {/* <FormError errors={alert} name={"district_id"} /> */}

                            {/* <FontAwesomeIcon icon={faChevronDown} className="absolute left-36 top-3 text-gray-500 text-sm" /> */}
                        </div>
                    </div>
                </div>
                <div className="mb-2 flex flex-col md:flex-row gap-5">
                    <div className="w-full md:w-1/2 pb-4">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                            Nombre de contacto
                        </label>
                        <Input
                            type="text"
                            // label="Nombre de contacto"
                            value={formulario.contact_name}
                            name="contact_name"
                            className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
                            alert={alert}
                            required={true}
                            onChange={(e) => hanldeChange({ target: { name: 'contact_name', value: e.target.value } })}
                            placeholder={"Nombre de contacto"}
                        />
                    </div>
                    <div className="w-full md:w-1/2 pb-4">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white">
                            Teléfono de contacto
                        </label>
                        <Input
                            type="text"
                            // label="Teléfono de contacto"
                            value={formulario.contact_phone}
                            mask={"9999-9999"}
                            name="number"
                            className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
                            alert={alert}
                            required={true}
                            onChange={(e) => hanldeChange({ target: { name: 'contact_phone', value: e.target.value } })}
                            placeholder={"Teléfono de contacto"}
                        />
                    </div>
                </div>

                {/* <div className="mb-4 flex flex-row gap-1">
                    <div className="">
                        <label className="mb-1 block font-medium text-xs text-slate-700 dark:text-white ">
                            Número de teléfono
                        </label>
                        <div className="relative flex flex-row gap-1">
                            <div className="relative w-1/2">
                                <select type="text"
                                    className="w-full text-xs md:text-sm rounded-md border border-stroke placeholder-stone-400 dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6  outline-none appearance-none p-2 pr-8  text-stone-400  focus:border-turquesa dark:text-white focus-visible:shadow-none">
                                    <option className="text-stone-400" value="opcion1">+503</option>
                                    <option value="opcion2">No</option>
                                </select>
                            </div>
                            <Input
                                type="text"
                                placeholder="0000-0000"
                                className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 bg-transparent py-2 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
                                alert={alert}
                                mask="9999-9999"
                                onChange={(e) => setFormulario({ ...formulario, phone: e.target.value })}
                            />
                            <FormError errors={alert} name={"phone"} />
                        </div>
                    </div>
                </div> */}
            </form>
        </>
    )
}

export default InfoOrg;